<template>
  <div v-if="bodyShow" class="buying-tickets-information" :style="{overflow:buyTikShow?'hidden':'auto'}">
      <!-- 商品信息 -->
    <div class="goods-information">
        <div class="title">
            <div class="line"></div>
            <span>商品信息</span>
        </div>
        <div class="box">
            <img class="left" :src="item.thumb?item.thumb:'https://misc.xjy.cn/zuoziji/fm.jpg'" alt="">
            <div class="text">
                <div class="h3 text-ellipsis-2">
                    {{item.name}}
                </div>
                <div class="city">
                    <img src="@a/be-myself/2020/city-min.png" alt="">
                    <span>{{item.province+' '+item.city}}  会场</span>
                </div>
<!--                <div class="time">-->
<!--                    <img src="@a/be-myself/2020/time.png" alt="">-->
<!--                    <span class="t">12月30日·{{JSON.parse(item.detail)?JSON.parse(item.detail).createTime:''}}</span>-->
<!--                </div>-->
            </div>
        </div>
    </div>
    <!-- 个人信息 -->
    <div class="userinfor">
        <div class="title">
            <div class="line"></div>
            <span>填写个人信息</span>
        </div>
        <input class="input" type="text" v-model="name" placeholder="请填写真实姓名">
        <input class="input" type="text" v-model="phone" placeholder="请填写手机号码">
        <p>主要用于入场验证，请仔细填写</p>
    </div>
    <!-- 老友码 -->
<!--    <div class="userinfor on">-->
<!--        <div class="title">-->
<!--            <div class="line"></div>-->
<!--            <span>老友码（仅用于报名北京主论坛现场票）</span>-->
<!--        </div>-->
<!--        <input  v-model="coupon" class="input on" type="text" placeholder="请输入老友码">-->
<!--        <div @click="vaildCode()" class="cfmBtn">确认</div>-->
<!--    </div>-->
    <!-- 付款信息 -->
    <div class="userinfor on">
        <div class="title">
            <div class="line"></div>
            <span>付款信息</span>
        </div>
        <div class="money one">
            <span class="left">应付金额</span>
            <span class="right">¥{{item.price/100}}</span>
        </div>
        <div class="money">
            <span class="left">优惠金额</span>
            <span class="right">¥{{discount_price?(discount_price/100):0}}</span>
        </div>
        <div class="money on">
            <span class="left">实付金额</span>
            <span class="right on">¥{{discount_price?(item.price-discount_price)/100:((item.price/100)>0?(item.price/100):0)}}</span>
        </div>
    </div>
    <!-- 购票按钮 -->
    <button @click="createOrderHandle()" class="payBtn">点击购票</button>
    <!-- 引入组件 -->
    <buying-tickets-success v-if="buyTikShow" :d2="d2" :oid="oid" :name="name" :phone="phone" :price="discount_price?(item.price-discount_price)/100:((item.price/100)>0?(item.price/100):0)" :itemObj="item" class="buy-scssess"></buying-tickets-success>
  </div>
</template>

<script>
import { productGet,checkCoupon,createOrder,cancelOrder,saveInfo } from "@/api/be_myself"
import { phoneValidation } from "@u/validation";
import BuyingTicketsSuccess from "../buying_tickets_success/index"
import wx from "weixin-js-sdk";
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            bodyShow:false,
            name:'',
            phone:null,
            item:{},
            coupon:'',
            discount_price:null,
            buyTikShow:false,
            oid:null,
            d2:{}
        }
    },
    components: {
        BuyingTicketsSuccess
    },
    methods:{
        // 创建订单
        createOrderHandle(){
            if(!this.name || !this.phone){
                this.$toast('姓名和手机号不能为空！');
                return
            }else if(!phoneValidation(this.phone)){
                this.$toast('手机号不正确！');
                return
            }
            //调用加载中
            this.$emit('loadingHandle',true,"创建订单中...");
            let obj = {
                product_id:this.$route.query.product_id
            };
            if(this.coupon && this.discount_price){
                obj['coupon'] = this.coupon;
            }
            createOrder(obj).then((data)=>{
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }

                saveInfo({
                    order_id:data.order_id,
                    name:this.name,
                    phone:this.phone
                }).then((d2)=>{
                    if(d2.error>0){
                        this.$toast(d2.detail);
                        return
                    }
                    this.d2 = d2.item;
                    let dd = JSON.stringify(data.params);
                    let data_ = eval("(" + dd + ")");
                    let jsApiCall = () => {
                        WeixinJSBridge.invoke("getBrandWCPayRequest", data_, rest => {
                            //关闭加载中
                            this.$emit('loadingHandle',false);
                            WeixinJSBridge.log(rest.err_msg);
                            if (rest.err_msg == "get_brand_wcpay_request:ok") {
                                this.payModelShow = false;
                                this.$toast({
                                    message:'支付成功',
                                    onClose:()=>{
                                        this.oid = data.order_id;
                                        this.buyTikShow = true;
                                    }
                                });
                            } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                                cancelOrder({
                                    order_id:data.order_id
                                }).then();
                                alert("支付取消");
                            } else {
                                cancelOrder({
                                    order_id:data.order_id
                                }).then();
                                alert("支付失败");
                            }
                        });
                    };

                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
                        } else if (document.attachEvent) {
                            document.attachEvent("WeixinJSBridgeReady", jsApiCall);
                            document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
                        }
                    } else {
                        jsApiCall();
                    }
                });
            });
        },
        // 验证优惠码
        vaildCode(){
            if(this.coupon){
                checkCoupon({
                    product_id:this.$route.query.product_id,
                    coupon:this.coupon
                }).then(data=>{
                    if(data.error>0){
                        this.$toast(data.msg);
                        return
                    }
                    if(data.discount>0){
                        this.discount_price = data.discount;
                    }
                });
            }
        },
        // 查询商品数据
        pullData(){
            if(!this.$route.query.product_id){
                this.$toast('商品id不能为空！');
                return
            }
            let q = this.$route.query;
            //调用加载中
            // this.$emit('loadingHandle',true,"新年第一天我要做自己ヾ(◍°∇°◍)ﾉﾞ...");
            this.$emit('loadingHandle',true,"超级个体，更值钱更热爱更自在(σ≧∀≦σ)");
            productGet({
                id:this.$route.query.product_id
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                this.item = data.item;
                this.item.product_detail = data.item.detail;
                this.item.product_id = data.item.id;

                this.bodyShow =true;
                shareCon("beMyself", this);

            });
        }
    },  
    created(){
        this.pullData();

      // this.discount_price = 3;
      // // this.item = {'oid':4033,'name':"高龙",'phone':"15041281191",'product_price':"0"};
      // this.item = {"id":4033,"app_id":1,"user_id":671865,"product_id":2,"extension_id":null,"coupon":null,"price":3,"pay_time":null,"refund_time":null,"status":1,"related_order_id":37172,"order_no":"20231202151528371725483","trade_no":null,"create_time":"2023-12-02 15:15:28","expire_time":"2023-12-02 15:25:28","code":"009","name":"高龙","phone":"15041281191","date":null,"time":null,"information":null,"collection":null,"remark":null,"ceping_order_id":null,"ceping_product_id":null,"related_ceping_id":null,"product_name":"测试商品","product_display_name":null,"product_price":3,"product_original_price":null,"product_detail":"{\"createTime\":\"2020-12-09T06:28:24.000Z\"}","province":"北京市","city":"北京城区","district":"东城区","ceping_id":null,"base_count":null,"sold":3,"channel_id":null,"type":null,"category_id":1,"product_user_list":[{"id":5,"user_id":21,"product_id":2,"user_name":"刘莹","user_phone":"15210356574"}],"nickname":"高龙","headimgurl":"https:\/\/thirdwx.qlogo.cn\/mmopen\/vi_32\/Q0j4TwGTfTJk8JZ83XvQLmuEHYmFKCiaM9Va6ZwS4pEXZjQqwTLL6nyq2r3tVW1KrMN8eUM5PEIVGVgglUkHicoQ\/132"};
      // this.oid = 4033;
      // this.name = "高龙";
      // this.phone = "15041281191";
      // this.buyTikShow = true;

    }
}
</script>

<style lang="scss" scoped>
.buying-tickets-information{
    padding-top: 4px;
    position: relative;
    padding-bottom: 100px;
    .buy-scssess{
        position: fixed;
        width: 100%;
        max-width: 750px;
        min-height: 100%;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 888;
        background-color: #F5F5F5;
    }
    .goods-information{
        padding: 20px 24px;
        background-color: #FFFFFF;
        .title{
            display: flex;
            align-items: center;
            font-size:32px ;
            color: #333333;
            font-weight: 500;
            margin-bottom: 24px;
            .line{
                width: 8px;
                height: 20px;
                border-radius: 4px;
                background-color: #FF9800;
                margin-right: 12px;
            }
            span{
                line-height: 1;
            }
        }
        .box{
            padding: 24px;
            background: #FFFFFF;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.23);
            border-radius: 8px;
            display: flex;
            margin-bottom: 24px;
            &:last-child{
                margin-bottom: 0px;
            }
            .left{
                width: 178px;
                height: 212px;
                margin-right: 10px;
            }
            .text{
                flex: 1;
                .h3{
                    font-size: 32px;
                    color: #333333;
                    line-height: 48px;
                    font-weight: bold;
                    margin-bottom: 15px;
                    width: 465px;
                }
                .city{
                    display: flex;
                    align-items: center;
                    margin-bottom: 12px;
                    img{
                        width: 30px;
                    }
                    span{
                        font-size: 28px;
                        color: #999999;
                        margin-left: 10px;
                        line-height: 44px;
                    }
                }
                .time{
                    display: flex;
                    align-items: center;
                    img{
                        width: 26px;
                        height: 26px;
                    }
                    .t{
                        font-size: 28px;
                        color: #999999;
                        margin-left: 10px;
                        margin-right: auto;
                    }
                }
            }
        }
    }
    .userinfor{
        padding: 20px 24px;
        background-color: #FFFFFF;
        margin-top: 8px;
        .title{
            display: flex;
            align-items: center;
            font-size:32px ;
            color: #333333;
            font-weight: 500;
            margin-bottom: 30px;
            .line{
                width: 8px;
                height: 20px;
                border-radius: 4px;
                background-color: #FF9800;
                margin-right: 12px;
            }
            span{
                line-height: 1;
            }
        }
        .input{
            width: 100%;
            border: none;
            border-bottom:1px solid #E4E4E4 ;
            line-height: 96px;
            font-size: 28px;
            outline: none;
        }
        .input:nth-of-type(1){
            border-top: 1px solid #E4E4E4;
        }
        .input.on{
            border-bottom:none ;
        }
        .money{
            width: 100%;
            display: flex;
            align-items: center;
            border: none;
            border-bottom:1px solid #E4E4E4 ;
            line-height: 96px;
            height: 96px;
            font-size: 28px;
            
            &:last-of-type{
                border-bottom: none;
            }
            .left{
                color: #8C8C8C;
                font-weight: 400;
                line-height: 48px;
                margin-right: auto;
            }
            .right{
                font-weight: 400;
                color: #222222;
                line-height: 48px;
            }
            .right.on{
                font-weight: 600;
                color: #F55F01;
            }
        }
        
        .money.on{
            border-bottom:none ;
        }
       .money.one{
            border-top: 1px solid #E4E4E4 ;
        }
        p{
            font-size: 24px;
            color: #606060;
            line-height: 1;
            margin-top: 25px;
            font-weight: 400;
        }
    }
    .userinfor.on{
        padding-bottom: 0;
        position: relative;
        .cfmBtn{
            height: 48px;
            line-height: 48px;
            color: #0890CE;
            position: absolute;
            right: 20px;
            bottom: 25px;
            // border: 1px solid #0890ce;
            padding: 0px 20px;
        }
    }
    .payBtn{
        display: block;
        border: none;
        position: fixed;
        height: 100px;
        line-height: 100px;
        width: 100%;
        max-width: 750px;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        //background-color: #0890CE;
        background-color: #ff504c;
        font-weight: 600;
        color: #FFFFFF;
        font-size: 32px;
        text-align: center;
    }
}
</style>